import React from 'react'
import './style.css'
import VideoModal from '../../components/ModalVideo'

const VedioCta = (props) => {
    const { videoId, videoImg } = props;
    
    return(
        <div className="wpo-about-video-area">
            <div className="container">
                <div className="row">
                    <div className="col-lg-8 offset-lg-2">
                        <div className="wpo-about-video-item">
                            <div className="wpo-about-video-img">
                                <img src={videoImg} alt=""/>
                                <div className="entry-media video-holder video-btn2">
                                    <VideoModal videoId={videoId}/>
                                </div>
                            </div>
                            {/* <h2>See what we do for the <span>poor people and the children</span></h2> */}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default VedioCta;